export default __webpack_public_path__ + "static/media/eattt.585ce294.gif";